import { useEffect, useState } from "react";
import { UseKeyPressed } from "./types";

export const useKeyPressed: UseKeyPressed = ({
  code,
  isDisabled = false,
  preventDefault = false,
}) => {
  const [isPressed, setIsPressed] = useState(false);

  useEffect(() => {
    if (isDisabled) {
      setIsPressed(false);
      return;
    }

    const down = (e: KeyboardEvent) => {
      if (e.code === code) {
        if (preventDefault) {
          e.preventDefault();
        }
        setIsPressed(true);
      }
    };

    const up = (e: KeyboardEvent) => {
      if (e.code === code) setIsPressed(false);
    };

    // A key released outside the window never fires keyup here, so it would stay stuck pressed.
    const release = () => setIsPressed(false);

    const releaseWhenHidden = () => {
      if (document.visibilityState === "hidden") setIsPressed(false);
    };

    window.addEventListener("keydown", down);
    window.addEventListener("keyup", up);
    window.addEventListener("blur", release);
    document.addEventListener("visibilitychange", releaseWhenHidden);

    return () => {
      window.removeEventListener("keydown", down);
      window.removeEventListener("keyup", up);
      window.removeEventListener("blur", release);
      document.removeEventListener("visibilitychange", releaseWhenHidden);
    };
  }, [code, isDisabled, preventDefault]);

  return isPressed;
};
